import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {InvenTypeVo} from '../../common/shared/api/gateway/enums/InvenTypeVo.enum';
import type {ItemSeriesResultDto} from '../../common/shared/api/gateway/ItemSeriesResultDto.interface';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';

/**
 * 인벤 추천 목록 조회
 *
 * Origin: pageNicolasApi.getInvenRecommedList
 * API: GET /api/v1/inven/recommend
 */
export async function getInvenRecommend(
  type: InvenTypeVo,
  options?: FetcherOptions
): Promise<ApiResultV2Vo<ItemSeriesResultDto>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/recommend',
    {
      method: 'GET',
      params: {
        type,
      },
    },
    options
  );
  return response.data;
}
